import { useEffect, useRef } from 'react';

import { useRemoteConfig } from 'core/hooks/use-remote-config';

/**
 * Stripe deferred-email flow (`collectEmailAfterPayment`): the user pays as an
 * anonymous user and only submits their email AFTER payment, so the Facebook
 * `CompleteRegistration` event that normally fires on email submit would arrive
 * late (or never, if the user drops off before email-after-payment). When the
 * flag is on, fire `CompleteRegistration` as soon as the user lands on a paywall
 * page (and on dynamic-personal-plan) instead. No-op when the flag is off.
 *
 * Fires at most once per mount so remounts within the same visit don't duplicate
 * the event.
 */
export function useCompleteRegistrationEvent() {
  // @ts-ignore — collectEmailAfterPayment lives on the core RemoteConfig type
  const { collectEmailAfterPayment } = useRemoteConfig();
  const firedRef = useRef(false);

  useEffect(() => {
    if (!collectEmailAfterPayment || firedRef.current) return;
    firedRef.current = true;
    // @ts-ignore — fbq is injected by the Facebook Pixel snippet
    window.fbq?.('track', 'CompleteRegistration');
    // @ts-ignore — ttq is injected by the TikTok Pixel snippet (TikTok traffic only)
    window.ttq?.track('CompleteRegistration');
  }, [collectEmailAfterPayment]);
}
